/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_ecc_l = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low`)
};

const es_qr_ecc_l = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baja`)
};

const de_qr_ecc_l = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedrig`)
};

const nl_qr_ecc_l = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laag`)
};

const fr_qr_ecc_l = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faible`)
};

const it_qr_ecc_l = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bassa`)
};

const pt_br2_qr_ecc_l = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixa`)
};

const pt_qr_ecc_l = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixa`)
};

const ja_qr_ecc_l = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低`)
};

const zh_qr_ecc_l = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_ecc_l = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_ecc_l(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_ecc_l", locale)
	if (locale === "en") return en_qr_ecc_l(inputs)
	if (locale === "es") return es_qr_ecc_l(inputs)
	if (locale === "de") return de_qr_ecc_l(inputs)
	if (locale === "nl") return nl_qr_ecc_l(inputs)
	if (locale === "fr") return fr_qr_ecc_l(inputs)
	if (locale === "it") return it_qr_ecc_l(inputs)
	if (locale === "pt-BR") return pt_br2_qr_ecc_l(inputs)
	if (locale === "pt") return pt_qr_ecc_l(inputs)
	if (locale === "ja") return ja_qr_ecc_l(inputs)
	return zh_qr_ecc_l(inputs)
};